import flip from "images/flip.svg";
import React from "react";
import ReactSVG from "react-svg";
import * as S from "./styles";

var ProductView3DControls = function ProductView3DControls(_ref) {
  var onFlip = _ref.onFlip,
      onZoomIn = _ref.onZoomIn,
      onZoomOut = _ref.onZoomOut;
  return React.createElement(S.Wrapper, null, React.createElement(S.Button, {
    className: "product-view__dimension-view",
    onClick: onZoomIn
  }, React.createElement("span", null, "\uFF0B"), " "), React.createElement(S.Button, {
    className: "product-view__side-view",
    onClick: onZoomOut
  }, React.createElement("span", null, "\uFF0D"), " "), React.createElement(S.Button, {
    className: "product-view__side-view",
    onClick: onFlip
  }, React.createElement(ReactSVG, {
    path: flip
  })));
};

export { ProductView3DControls };